import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import BtChecklistSelect from '../bt-checklist-select/bt-checklist-select';
import { HELA_SVERIGE, placeChecklist } from './placeChecklist';

const OPEN_FROM_THE_START = [HELA_SVERIGE];

type Props = {
  places: string[],
  onChange: (places: string[]) => void,
};

const AppPlaceChecklist: FC<Props> = ({ places, onChange }) => {
  const [t] = useTranslation('supplierDatabase');
  return (
    <BtChecklistSelect
      placeholder={t('supplierDetailPanel.profileInfo.places.placeholder', 'Platser')}
      options={placeChecklist}
      value={places}
      onChange={onChange}
      groupsSelectable
      defaultExpanded={OPEN_FROM_THE_START}
    />
  );
};

export default AppPlaceChecklist;
